import { useId, useMemo } from 'react';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import { AutoCompleteOptionType } from '../CandidateFilter/CandidateFilter.types';
import StatusTag from '../StatusTag';

type StarType = {
  numberOfStars: number;
};

export const Status = (props): JSX.Element => {
  return <StatusTag {...props} />;
};

export const Checkbox = ({ label, checked, ...props }: AutoCompleteOptionType): JSX.Element => {
  const checkboxId = useId();
  return (
    <label htmlFor={checkboxId}>
      <input
        readOnly
        style={{ marginRight: 4, pointerEvents: 'none' }}
        id={checkboxId}
        checked={checked}
        type="checkbox"
        {...props}
      />
      {label}
    </label>
  );
};

export const Text = ({ children, ...props }: AutoCompleteOptionType): JSX.Element => {
  return <p {...props}>{children}</p>;
};

export const Stars = ({ numberOfStars, ...props }: StarType): JSX.Element => {
  const stars = useMemo(() => {
    const starsCount = [0];
    for (let i = 1; i <= numberOfStars; i += 1) {
      starsCount.push(i);
    }
    return starsCount.filter(Boolean);
  }, [numberOfStars]);

  return (
    <div {...props}>
      {stars.map((number) => {
        return <StarOutlinedIcon key={number} sx={{ width: 12, color: '#A8BFF2' }} />;
      })}
    </div>
  );
};
